export default __webpack_public_path__ + "static/media/CacheLRU.4b731295.jpg";